export const CAMPAIGN_FOLDER_REQUEST="CAMPAIGN_FOLDER_REQUEST";
export const CAMPAIGN_FOLDER_SUCCESS="CAMPAIGN_FOLDER_SUCCESS";
export const CAMPAIGN_FOLDER_FAIL="CAMPAIGN_FOLDER_FAIL";